import { render, staticRenderFns } from "./LandingNoListFR.vue?vue&type=template&id=726a71f8&scoped=true"
import script from "./LandingNoListFR.vue?vue&type=script&lang=js"
export * from "./LandingNoListFR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "726a71f8",
  null
  
)

export default component.exports